import Vue from "vue";
// Components that are registered globaly.
import Language from "./Language";
import PlaceAutocompleteNearStore from "./autocomplete/PlaceAutocompleteNearStore";
import PlaceAutocompleteInput from "./autocomplete/PlaceAutocompleteInput";
import TimeLeft from "./times/TimeLeft";
import TimeLeftCounter from "./times/TimeLeftCounter";
import ExtraTimeOrder from "./times/ExtraTimeOrder";
import ModalAuthForm from "./auth/ModalAuthForm";
import MenuHeaderPublic from "./menu-headers/MenuHeaderPublic";
import MenuStores from "./menu-headers/MenuStores";
import CardModal from "./modal/CardModal";
import CardOrders from "./cards/CardOrders";
import CardEmptyList from "./cards/CardEmptyList";
import CardTemplate from "./CardTemplate";
import CardDefault from "./cards/CardDefault";
import DatatableSearch from "./datatables/DatatableSearch";
import Logo from "./Logo";
import ButtonSuccess from "./buttons/ButtonSuccess";
import ButtonCancel from "./buttons/ButtonCancel";
import ButtonOther from "./buttons/ButtonOther";
import DatePickerRange from "./datepicker/DatePickerRange";
import DatePickerRangeOptions from "./datepicker/DatePickerRangeOptions";
import AppServicesAutocomplete from "./autocomplete/AppServicesAutocomplete";
import AppPaymentTypesAutocomplete from "./autocomplete/AppPaymentTypesAutocomplete";
import AppOrderTypesAutocomplete from "./autocomplete/AppOrderTypesAutocomplete";
import AppUserTypesAutocomplete from "./autocomplete/AppUserTypesAutocomplete";
import AppOrderStatusAutocomplete from "./autocomplete/AppOrderStatusAutocomplete";
import ExcelExport from "./exports/ExcelExport";
import NewUpdates from "./notifications/NewUpdates";
import IntercomCustomers from "./intercom/IntercomCustomers";
import InputColorHex from "./inputs/InputColorHex";
import SelectReasonsRefund from "./selects/SelectReasonsRefund";
import SpinnerLoader from "./SpinnerLoader";
import ProfileCustomer from "./ProfileCustomer";
import CreditCardComponent from "./cards/CreditCardComponent.vue";
import CardItemsComponents from "./cards/CardItemsComponents.vue";
import CardItemsExpandComponents from "./cards/CardItemsExpandComponents.vue";

[
  Language,
  PlaceAutocompleteNearStore,
  PlaceAutocompleteInput,
  TimeLeft,
  TimeLeftCounter,
  ExtraTimeOrder,
  ModalAuthForm,
  MenuHeaderPublic,
  MenuStores,
  CardModal,
  CardTemplate,
  CardDefault,
  CardOrders,
  CardEmptyList,
  DatatableSearch,
  Logo,
  ButtonSuccess,
  ButtonCancel,
  ButtonOther,
  DatePickerRange,
  DatePickerRangeOptions,
  AppServicesAutocomplete,
  AppPaymentTypesAutocomplete,
  AppOrderTypesAutocomplete,
  AppUserTypesAutocomplete,
  AppOrderStatusAutocomplete,
  ExcelExport,
  NewUpdates,
  IntercomCustomers,
  InputColorHex,
  SelectReasonsRefund,
  SpinnerLoader,
  ProfileCustomer,
  CreditCardComponent,
  CardItemsComponents,
  CardItemsExpandComponents,
].forEach((Component) => {
  Vue.component(Component.name, Component);
});
